module.exports = __webpack_public_path__ + "static/media/image_11.5475d03c.png";